/**
 * Single Job Position — Share widget in the sidebar.
 */

import { initShareWidget } from './share-widget';

document.querySelectorAll( '.single-job' ).forEach( initShareWidget );
